import React, { Component } from 'react';
import { AuthContext } from './AuthProvider';

const withAuth = ComponentToWrap => {
  return class AuthComponent extends Component {
    static contextType = AuthContext;

    render() {
      const { authState, authSession, authActions, authUser } = this.context;
      return (
        <ComponentToWrap
          {...this.props}
          authState={authState}
          authSession={authSession}
          authActions={authActions}
          authUser={authUser}
        />
      );
    }
  };
};

export default withAuth;



// WEBPACK FOOTER //
// ./src/auth/withAuth.js